(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/self-exclusion-react/assets/react/pages/self-exclusion-main.js') >= 0) return;  svs.modules.push('/modules/self-exclusion-react/assets/react/pages/self-exclusion-main.js');

'use strict';

const {
  Grid,
  GridCol,
  GridRow
} = svs.ui.ReactGrid;
const {
  useAtom
} = jotai;
const {
  activeExclusionsAtom,
  isNaExcludedAtom
} = svs.selfExclusion.store.selfExclusionAtoms;
const {
  SelfExclusion24,
  SetSelfExclusion,
  NationalSelfExclusion,
  Information,
  ActiveExclusions,
  GamePauseInfo,
  SelfExclusion24AbTest,
  SetSelfExclusionAbTest,
  NationalSelfExclusionAbTest,
  InformationAbTest,
  ActiveExclusionsAbTest
} = svs.selfExclusion.components;
const SelfExclusionMain = () => {
  var _svs$core$config$data;
  const [exclusions] = useAtom(activeExclusionsAtom);
  const [naExcluded] = useAtom(isNaExcludedAtom);
  const hasExclusions = exclusions.length > 0 || naExcluded;
  const isPnp = ((_svs$core$config$data = svs.core.config.data) === null || _svs$core$config$data === void 0 || (_svs$core$config$data = _svs$core$config$data.svsconfig) === null || _svs$core$config$data === void 0 ? void 0 : _svs$core$config$data.site) === 'momang';
  const isInTarget = svs.components.targeting.isTargeted('self_exclusion_design', 'B') && !isPnp;
  if (isInTarget) {
    return React.createElement("main", {
      id: "self-exclusion-overview"
    }, React.createElement("h2", {
      className: "align-center font-weight-700"
    }, "Spelpaus"), React.createElement("p", {
      className: "align-center"
    }, "V\xE4lj sj\xE4lv vad du vill ta en paus fr\xE5n och hur l\xE5ng pausen ska vara."), React.createElement(Grid, null, React.createElement(GridRow, {
      className: "padding-xs-h-1",
      md: {
        gutter: 3
      },
      xs: {
        gutter: 3
      }
    }, React.createElement(GridCol, {
      am: 8,
      xs: 12
    }, hasExclusions && React.createElement(ActiveExclusionsAbTest, {
      exclusions: exclusions,
      naExcluded: naExcluded
    }), React.createElement(NationalSelfExclusionAbTest, null), React.createElement(SetSelfExclusionAbTest, null), React.createElement(SelfExclusion24AbTest, null), React.createElement(InformationAbTest, null)), React.createElement(GridCol, {
      am: 4,
      xs: 12
    }, React.createElement(GamePauseInfo, null)))));
  }
  return React.createElement("main", {
    id: "self-exclusion-overview"
  }, hasExclusions && React.createElement(ActiveExclusions, {
    exclusions: exclusions,
    naExcluded: naExcluded
  }), React.createElement(SelfExclusion24, null), React.createElement(SetSelfExclusion, null), React.createElement(NationalSelfExclusion, null), React.createElement(Information, null));
};
svs.selfExclusion.components.SelfExclusionMain = SelfExclusionMain;

 })(window);